const initialSnacks: Snack.SnackInput[] = [];

export default initialSnacks;
